/* SZW Projects (10/12). Two jobs in one file:
   1. Any page: wires [data-szw-project-add] buttons ("Save to project": the line under the sheets + the round
      button on the main photo, 10/13) - saves the SKU in this browser.
   2. The project page (body.szp): board + presentation sheet, share link, print.
   Storage: localStorage only (per designer, per browser). Share link = project packed into the URL #hash. */
(function () {
  'use strict';
  // the sheet-buttons snippet can render more than once per page (it loads this file each time) - wire up once
  if (window.__szwProjectInit) return;
  window.__szwProjectInit = true;
  var KEY = 'szw-projects-v1';
  // project page address: set by the colour-page snippet; on the project page itself = where we are
  var PAGE = window.SZW_PROJECT_URL || (document.body.classList.contains('szp') ? location.pathname + location.search.replace(/([?&])contact_posted=[^&]*&?/, '$1').replace(/[?&]$/, '') : '/pages/project');
  // (10/15: minus Shopify's contact_posted flag, or a share link made right after a guest sample request would open the thank-you window)

  function load() {
    try { var s = JSON.parse(localStorage.getItem(KEY)); if (s && Array.isArray(s.list)) return s; } catch (e) {}
    return { active: null, list: [] };
  }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  function uid() { return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function today() { return new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }); }
  function blank(name) {
    return { id: uid(), name: name || 'My project', client: '', room: '', by: '', date: today(), note: '',
             layout: 'pages', price: false, items: [], updated: Date.now() };
  }
  function active(s, create) {
    var p = s.list.filter(function (x) { return x.id === s.active; })[0] || s.list[0];
    if (!p && create) { p = blank(); s.list.push(p); }
    if (p) s.active = p.id;
    return p;
  }
  function normSku(v) { return String(v || '').split(/[\s\/]/)[0].replace(/-[SM]$/i, '').toUpperCase(); }

  /* ---------- share link: base64url(JSON), unicode safe ---------- */
  function pack(p) {
    var o = { n: p.name, c: p.client, r: p.room, b: p.by, d: p.date, t: p.note, l: p.layout,
              i: p.items.map(function (it) { return it.note ? [it.sku, it.note] : [it.sku]; }) };
    var bytes = new TextEncoder().encode(JSON.stringify(o)), bin = '';
    bytes.forEach(function (b) { bin += String.fromCharCode(b); });
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function unpack(str) {
    try {
      var bin = atob(str.replace(/-/g, '+').replace(/_/g, '/')), bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      var o = JSON.parse(new TextDecoder().decode(bytes)), p = blank(o.n || 'Shared project');
      p.client = o.c || ''; p.room = o.r || ''; p.by = o.b || ''; p.date = o.d || p.date; p.note = o.t || '';
      p.layout = o.l === 'grid' ? 'grid' : 'pages';
      p.items = (o.i || []).map(function (a) { return { sku: normSku(a[0]), note: a[1] || '' }; }).filter(function (x) { return x.sku; });
      return p;
    } catch (e) { return null; }
  }
  /* Simple form for links built elsewhere (Gmail add-on): #skus=SZH-0658,SZT-0103&n=Willow */
  function fromSimpleHash(h) {
    var q = new URLSearchParams(h);
    if (!q.get('skus')) return null;
    var p = blank(q.get('n') || 'Wallcovering selection');
    p.client = q.get('c') || ''; p.by = q.get('b') || '';
    p.items = q.get('skus').split(',').map(normSku).filter(Boolean).map(function (s) { return { sku: s, note: '' }; });
    return p;
  }

  /* ---------- 1. Save-to-project buttons (colour pages) ----------
     10/13 (owner chose A + D): the quiet "Save to project" line under the sheets (snippets/szw-sheet-buttons) and the
     round save button on the main photo (made here, fab()). Both are [data-szw-project-add], so one press updates both,
     the "View project (N)" count and anything else that shows the project. No toast on a colour page: the line, the
     filled bookmark and the photo label already say it. */
  function toast(msg, link) {
    var t = document.querySelector('[data-szp-toast]');
    if (!t) { t = document.createElement('div'); t.className = 'szp-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '';
    t.appendChild(document.createTextNode(msg));
    if (link) { var a = document.createElement('a'); a.href = PAGE; a.textContent = 'View project'; t.appendChild(a); }
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }
  function refreshButtons(pulse) {
    var s = load(), p = active(s, false), have = {};
    if (p) p.items.forEach(function (it) { have[it.sku] = 1; });
    // 10/15 several projects: the line names the project it saves into ("Save to Hudson Loft"); before any project exists it
    // stays "Save to project" (the first press makes "My project")
    // 10/15: the default name is only a title (project page, menu); on the button a project without its own name reads
    // "Saved to project", not "Saved to My project"
    var nm = p && p.name && p.name.trim() !== 'My project' ? p.name : '';
    document.querySelectorAll('[data-szw-project-add]').forEach(function (b) {
      var on = !!have[normSku(b.getAttribute('data-sku'))];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = b.querySelector('[data-label]'); if (l) l.textContent = (on ? 'Saved to ' : 'Save to ') + (nm || 'project');
      var r = b.querySelector('[data-label-remove]'); if (r) r.textContent = 'Remove from ' + (nm || 'project');
      if (b.hasAttribute('data-szw-pfab')) b.setAttribute('aria-label', (on ? 'Saved to ' : 'Save to ') + (nm || 'project'));
    });
    document.querySelectorAll('[data-szw-pchoose]').forEach(function (c) { c.hidden = !p; });
    document.querySelectorAll('[data-szw-pmenu]').forEach(function (m) { if (!m.hidden) menuFill(m); });
    // "View project (N)": shown once the project holds anything; the number pulses once when it changes
    var n = p ? p.items.length : 0;
    document.querySelectorAll('[data-szw-project-count]').forEach(function (c) {
      var was = c.textContent;
      c.textContent = n;
      var a = c.closest('a');
      if (!a) return;
      a.hidden = !n;
      a.setAttribute('aria-label', n ? 'View project, ' + n + (n === 1 ? ' colour' : ' colours') : 'View project');
      if (pulse && n && String(n) !== was) { a.classList.remove('is-pulse'); void a.offsetWidth; a.classList.add('is-pulse'); clearTimeout(a._p); a._p = setTimeout(function () { a.classList.remove('is-pulse'); }, 900); }
    });
  }
  // D: the photo label "Saved · View project" shows for 2.5 s after a save made on the photo, then fades (circle stays filled)
  function tell(fab, on) {
    var w = fab.closest('.szw-pfab'), tag = w && w.querySelector('.szw-pfab__tag');
    if (!w || !tag) return;
    clearTimeout(w._t);
    w.classList.toggle('is-told', on);
    tag.setAttribute('tabindex', on ? '0' : '-1'); tag.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (on) w._t = setTimeout(function () { tell(fab, false); }, 2500);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-szw-project-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var sku = normSku(b.getAttribute('data-sku'));
    if (!sku) return;
    var s = load(), p = active(s, true), i = p.items.findIndex(function (it) { return it.sku === sku; }), added = i < 0;
    if (added) p.items.push({ sku: sku, note: '' }); else p.items.splice(i, 1);
    p.updated = Date.now(); save(s); refreshButtons(true);
    // every button for this colour (line + photo): the bookmark fills once, on the press only (never on a reload)
    document.querySelectorAll('[data-szw-project-add]').forEach(function (x) {
      if (normSku(x.getAttribute('data-sku')) !== sku) return;
      x.classList.remove('is-just-added');
      if (added) { void x.offsetWidth; x.classList.add('is-just-added'); clearTimeout(x._j); x._j = setTimeout(function () { x.classList.remove('is-just-added'); }, 700); }
      if (x.hasAttribute('data-szw-pfab')) tell(x, added && x === b);
    });
    b.classList.add('is-fresh');
    var st = document.querySelector('[data-szw-project-status]');
    if (st) st.textContent = added ? 'Saved to project' : 'Removed from project';
  });
  ['mouseleave', 'focusout'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-szw-project-add].is-fresh')) t.classList.remove('is-fresh');
    }, true);
  });
  // D: the round save button sits on the top-right corner of the photo frame in the main gallery - outside the
  // swiper, so a press never swipes the gallery or opens the zoom; it never moves.
  function fab() {
    var line = document.querySelector('product-info[id^="MainProduct"] [data-szw-psave] [data-szw-project-add]') ||
               document.querySelector('[data-szw-psave] [data-szw-project-add]');
    var pi = line && line.closest('product-info');
    var wrap = (pi || document).querySelector('media-gallery .product__media-gallery-viewer-wrap');
    if (!line || !wrap || wrap.querySelector('.szw-pfab')) return;
    var w = document.createElement('div');
    w.className = 'szw-pfab';
    w.innerHTML = '<a class="szw-pfab__tag" tabindex="-1" aria-hidden="true">Saved · View project</a>' +
      '<button type="button" class="szw-pfab__btn" data-szw-project-add data-szw-pfab aria-pressed="false" aria-label="Save to project">' +
      '<svg class="szw-bm" viewBox="0 0 16 16" aria-hidden="true"><path class="szw-bm__fill" d="M4 2h8v12l-4-3-4 3z"/><path class="szw-bm__line" d="M4 2h8v12l-4-3-4 3z"/></svg></button>';
    w.querySelector('a').href = PAGE;
    w.querySelector('button').setAttribute('data-sku', line.getAttribute('data-sku'));
    // keep pointer / touch starts away from the gallery's swipe and zoom
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) { w.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true }); });
    wrap.appendChild(w);
    wrap.classList.add('szw-pfab-on');
    var gap = 12, raf = 0;
    function place() {
      // 10/13 (Toshi, twice: "fix for once"): the button sits in ONE spot = the top-right corner of the 7 x 9 photo frame.
      // It depends only on the frame's layout size, never on the picture shown or when a picture loads, so paging the gallery,
      // a landscape photo or a late image can never move it. (Earlier versions followed the picture and moved.)
      raf = 0;
      var box = wrap.querySelector('.product__media-item-container');
      if (!box || !box.offsetWidth) return;
      w.style.setProperty('--szw-pfab-t', gap + 'px');
      w.style.setProperty('--szw-pfab-r', Math.max(0, wrap.clientWidth - box.offsetWidth) + gap + 'px');
    }
    function later() { if (!raf) raf = requestAnimationFrame(place); }
    place();
    [300, 1000, 2000, 3200].forEach(function (t) { setTimeout(later, t); });
    window.addEventListener('resize', later);
    if (window.ResizeObserver) new ResizeObserver(later).observe(wrap);
    // slide changes (swiper-slide-active) and szw.js placing the photo (szw-fit classes) both show up as class changes
    var list = wrap.querySelector('.product__media-list');
    if (list && window.MutationObserver) new MutationObserver(later).observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  /* 10/15 several projects: a small arrow after "Save to <project>" opens the list of this browser's projects - pick the one
     to save into, or start a new one by name. Built here so the colour-page snippet only needs the styles. */
  function menuFill(m) {
    var s = load(), cur = active(s, false);
    m.innerHTML = '';
    var h = document.createElement('p'); h.className = 'szw-pmenu__head'; h.textContent = 'Save colors to'; m.appendChild(h);
    var ul = document.createElement('ul'); ul.className = 'szw-pmenu__list';
    s.list.slice().sort(function (a, b) { return (b.updated || 0) - (a.updated || 0); }).forEach(function (p) {
      var li = document.createElement('li'), b = document.createElement('button');
      b.type = 'button'; b.className = 'szw-pmenu__item'; b.setAttribute('aria-pressed', cur && p.id === cur.id ? 'true' : 'false');
      var n = document.createElement('span'); n.className = 'szw-pmenu__name'; n.textContent = p.name || 'My project';
      var c = document.createElement('span'); c.className = 'szw-pmenu__count'; c.textContent = p.items.length;
      b.appendChild(n); b.appendChild(c);
      b.addEventListener('click', function () { var t = load(); t.active = p.id; save(t); closeMenus(); refreshButtons();
        var st = document.querySelector('[data-szw-project-status]'); if (st) st.textContent = 'Saving to ' + (p.name || 'My project'); });
      li.appendChild(b); ul.appendChild(li);
    });
    m.appendChild(ul);
    var f = document.createElement('form'); f.className = 'szw-pmenu__new';
    f.innerHTML = '<label class="visually-hidden" for="szwPNew">New project name</label><input id="szwPNew" type="text" maxlength="80" autocomplete="off" placeholder="New project name"><button type="submit">Create</button>';
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = load(), v = f.querySelector('input').value.replace(/\s+/g, ' ').trim(), names = {};
      t.list.forEach(function (x) { names[(x.name || '').toLowerCase()] = 1; });
      if (!v) { v = 'New project'; for (var k = 2; names[v.toLowerCase()]; k++) v = 'New project ' + k; }
      var p = blank(v); t.list.push(p); t.active = p.id; save(t); closeMenus(); refreshButtons(true);
      var st = document.querySelector('[data-szw-project-status]'); if (st) st.textContent = 'Saving to ' + v;
    });
    m.appendChild(f);
  }
  function closeMenus() {
    document.querySelectorAll('[data-szw-pmenu]').forEach(function (m) { m.hidden = true; });
    document.querySelectorAll('[data-szw-pchoose]').forEach(function (c) { c.setAttribute('aria-expanded', 'false'); });
  }
  function chooser() {
    document.querySelectorAll('[data-szw-psave]').forEach(function (row) {
      if (row.querySelector('[data-szw-pchoose]')) return;
      var btn = row.querySelector('.szw-psave__btn'); if (!btn) return;
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'szw-psave__choose'; c.setAttribute('data-szw-pchoose', ''); c.hidden = true;
      c.setAttribute('aria-haspopup', 'true'); c.setAttribute('aria-expanded', 'false'); c.setAttribute('aria-label', 'Choose a project');
      c.innerHTML = '<svg viewBox="0 0 10 6" width="10" height="6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
      btn.insertAdjacentElement('afterend', c);
      var m = document.createElement('div'); m.className = 'szw-pmenu'; m.setAttribute('data-szw-pmenu', ''); m.hidden = true;
      m.setAttribute('role', 'group'); m.setAttribute('aria-label', 'Choose a project');
      row.appendChild(m);
      c.addEventListener('click', function (e) {
        e.stopPropagation(); var open = m.hidden; closeMenus();
        if (open) { menuFill(m); m.hidden = false; c.setAttribute('aria-expanded', 'true'); var f = m.querySelector('.szw-pmenu__item[aria-pressed="true"]') || m.querySelector('button'); if (f) f.focus(); }
      });
    });
  }
  document.addEventListener('click', function (e) { if (!(e.target.closest && e.target.closest('[data-szw-pmenu], [data-szw-pchoose]'))) closeMenus(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(); });

  /* "What is this?" (10/12 owner review): hover on desktop and keyboard focus are CSS; a tap toggles it on a phone,
     a tap anywhere else or Esc closes it. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.szw-pinfo__btn');
    document.querySelectorAll('[data-szw-pinfo].is-open').forEach(function (w) {
      if (!btn || !w.contains(btn)) { w.classList.remove('is-open'); w.querySelector('.szw-pinfo__btn').setAttribute('aria-expanded', 'false'); }
    });
    if (!btn) return;
    var w = btn.closest('[data-szw-pinfo]'), open = !w.classList.contains('is-open');
    w.classList.toggle('is-open', open); w.classList.toggle('is-closed', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-szw-pinfo]').forEach(function (w) {
      if (w.classList.contains('is-open') || w.contains(document.activeElement)) {
        w.classList.remove('is-open'); w.classList.add('is-closed'); w.querySelector('.szw-pinfo__btn').setAttribute('aria-expanded', 'false');
      }
    });
  });
  // a closed tip opens again on the next hover / focus
  ['mouseleave', 'focusout'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var w = e.target && e.target.closest && e.target.closest('[data-szw-pinfo]');
      if (w && (ev === 'mouseleave' ? e.target === w : !w.contains(e.relatedTarget))) w.classList.remove('is-closed');
    }, true);
  });
  // the selected colour can change without a reload (variant picker). Hyper fires 'variant:changed' on document
  // with detail.variant (assets/product-info.js); take the new SKU from it, then re-check the buttons.
  function onVariant(e) {
    var v = e && e.detail && e.detail.variant;
    if (v && v.sku) {
      document.querySelectorAll('[data-szw-project-add]').forEach(function (b) { b.setAttribute('data-sku', normSku(v.sku)); });
    }
    refreshButtons();
  }
  document.addEventListener('variant:changed', onVariant);
  document.addEventListener('variant:change', onVariant);
  window.addEventListener('storage', function () { refreshButtons(); });

  if (!document.body.classList.contains('szp')) {
    var start = function () { chooser(); fab(); refreshButtons(); };
    if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
    return;
  }

  /* ---------- 2. Project page ---------- */
  var CFG = window.SZP_CFG || {};
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var state = load(), proj, shared = false, cache = {}, indexP = null;

  // 10/15 guest sample request: Shopify's contact form returns to this page without the shared-project #hash
  // (or with its own #form id), so a client on a shared link would land on an empty project. Put the hash back first.
  var GS_KEY = 'szwGuestSamples', GS_MAX = 3, GS_HASH = 'szpGsHash';
  (function () {
    var back = document.querySelector('[data-szw-gs-done], [data-szw-gs-error]'), saved = null;
    try { saved = sessionStorage.getItem(GS_HASH); if (back) sessionStorage.removeItem(GS_HASH); } catch (e) {}
    if (back && saved && !/^#(p=|.*skus=)/.test(location.hash)) history.replaceState(null, '', location.pathname + location.search + saved);
  })();
  var h = location.hash.replace(/^#/, '');
  if (h) {
    var sp = h.indexOf('p=') === 0 ? unpack(h.slice(2)) : fromSimpleHash(h);
    if (sp) { proj = sp; shared = true; }
  }
  if (!proj) { proj = active(state, true); save(state); }

  function persist() {
    proj.updated = Date.now();
    if (!shared) save(state);
  }

  function index() {
    if (!indexP) indexP = fetch(CFG.index).then(function (r) { return r.json(); }).then(function (j) {
      var m = {}; (j.rows || []).forEach(function (r) { m[String(r[0]).toUpperCase()] = { handle: r[5], design: r[3], colour: r[4] }; });
      return m;
    }).catch(function () { return {}; });
    return indexP;
  }
  // approved installations baked into the theme (snippets/szw-installs-snapshot): first photo per colour SKU and per design
  var insP = null;
  function installs(m) {
    if (insP) return insP;
    insP = { sku: {}, design: {} };
    try {
      var tag = document.querySelector('[data-szw-installs-snapshot]'), list = tag ? JSON.parse(tag.textContent) : [];
      list.forEach(function (x) {
        var ph = (x.photos || [])[0]; if (!ph) return;
        String(x.sku || '').toUpperCase().split(/[\s,;\/]+/).filter(Boolean).forEach(function (k) {
          if (!insP.sku[k]) insP.sku[k] = ph;
          var dz = m[k] && String(m[k].design || '').toLowerCase();
          if (dz && !insP.design[dz]) insP.design[dz] = { ph: ph, sku: k };
        });
      });
    } catch (e) {}
    return insP;
  }
  function item(sku) {
    if (cache[sku]) return cache[sku];
    cache[sku] = index().then(function (m) {
      var row = m[sku];
      if (!row || !row.handle) return { sku: sku, missing: true };
      return fetch('/products/' + row.handle + '?view=projectdata', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw 0; return r.text(); })
        .then(function (t) {
          var d = JSON.parse(t), ins = installs(m);
          // 10/15 "In the room" = a REAL installation (Toshi: designers always ask for them). Order: this colour (approved
          // installation, then a product photo with this SKU in its file name), then the same design in another colour. The
          // caption names the colour on the wall so the client is never misled. Styled rolls / sets / charts never qualify
          // (product.projectdata.liquid).
          var nh = sku.replace(/-/g, ''), file = String(d.roomFile || '').toUpperCase();
          var fileSku = (file.match(/SZ[A-Z]-?\d{4}/) || [''])[0].replace(/^(SZ[A-Z])(\d)/, '$1-$2');
          // 10/15: photos checked by eye (snippets/szw-room-allow) carry the colour on the wall in roomSku (blank = not certain)
          var own = d.room && (d.roomAllow ? d.roomSku === sku : (file.indexOf(sku) > -1 || file.indexOf(nh) > -1));
          if (d.roomAllow) fileSku = d.roomSku || '';
          var dz = ins.design[String(row.design || '').toLowerCase()];
          function shownIn(k) { var r = m[k]; return k === sku ? 'Installation · this color' : 'Installation · shown in ' + k + (r && r.colour ? ' ' + r.colour : ''); }
          if (ins.sku[sku]) { d.room = ins.sku[sku]; d.roomCap = 'Installation · this color'; }
          else if (own) { d.roomCap = 'Installation · this color'; }
          else if (dz) { d.room = dz.ph; d.roomCap = shownIn(dz.sku); }
          else if (d.room) { d.roomCap = fileSku ? shownIn(fileSku) : 'Installation · this design'; }
          return d;
        })
        .catch(function () { return { sku: sku, design: row.design, colour: row.colour, missing: true }; });
    });
    return cache[sku];
  }

  // proj.price: false | 'retail' | 'net' (true from before 10/15 = retail). Net needs a trade login.
  var isTrade = false;
  function priceMode() { var v = proj.price; if (!v) return ''; if (v === 'net' && isTrade) return 'net'; return 'retail'; }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function img(src, alt, cls) { var i = el('img', cls); i.src = src; i.alt = alt || ''; i.loading = 'eager'; i.decoding = 'async'; return i; }
  // sample photos are square files with the 7:9 sample centred on white: frame + slight zoom crops the white (CSS .szp-ph)
  function frame(src, alt, cls) { var f = el('div', 'szp-ph' + (cls ? ' ' + cls : '')); if (src) f.appendChild(img(src, alt)); return f; }
  function num(i) { return (i < 9 ? '0' : '') + (i + 1); }
  function title(d) { return [d.design, d.colour].filter(Boolean).join(' · '); }

  function editableNote(it, cls) {
    var n = el('p', cls);
    n.contentEditable = 'true'; n.setAttribute('data-ph', 'Add a note for your client');
    n.textContent = it.note || '';
    n.classList.toggle('is-empty', !it.note);
    n.addEventListener('input', function () { it.note = n.textContent.trim(); n.classList.toggle('is-empty', !it.note); persist(); });
    return n;
  }
  function tools(idx) {
    var t = el('div', 'szp-tools'); t.setAttribute('data-noprint', '');
    [['↑', 'Move up', -1], ['↓', 'Move down', 1], ['Remove', 'Remove from project', 0]].forEach(function (b) {
      var x = el('button', 'szp-tool', b[0]); x.type = 'button'; x.title = b[1]; x.setAttribute('aria-label', b[1]);
      x.addEventListener('click', function () {
        if (b[2] === 0) proj.items.splice(idx, 1);
        else { var j = idx + b[2]; if (j < 0 || j >= proj.items.length) return; var tmp = proj.items[idx]; proj.items[idx] = proj.items[j]; proj.items[j] = tmp; }
        persist(); render();
      });
      t.appendChild(x);
    });
    return t;
  }
  function specs(d, cls) {
    var dl = el('dl', cls);
    (d.specs || []).forEach(function (kv) { var w = el('div'); w.appendChild(el('dt', null, kv[0])); w.appendChild(el('dd', null, kv[1])); dl.appendChild(w); });
    // 10/15: trade designers pick Retail or Net (Net only on purpose); everyone else only ever has the retail text
    var ptxt = priceMode() === 'net' ? d.price : (d.trade === 'true' ? d.retail : d.price);
    if (priceMode() && ptxt) {   // "Retail Price $94.00 / yard" -> label "Retail Price", value "$94.00 / yard"
      var pm = String(ptxt).match(/^((?:Retail|Net) Price)\s*(.*)$/i);
      var w = el('div', 'szp-price'); w.appendChild(el('dt', null, pm ? pm[1] : 'Price')); w.appendChild(el('dd', null, (pm ? pm[2] : ptxt).replace(/(\/ (?:yard|panel))\s+(?=\$)/, '$1 · ')));
      if (/mini/.test(cls || '')) dl.insertBefore(w, dl.firstChild); else dl.appendChild(w);
    }
    return dl;
  }
  // 10/15 (Toshi: fewer wasted samples): a "Sample" tick per colour, all ticked at the start, remembered per project.
  // Screen only (never printed); on a shared link the ticks show once the client presses Request samples.
  function pick(it) {
    var l = el('label', 'szp-pick'); l.setAttribute('data-noprint', '');
    var cb = el('input'); cb.type = 'checkbox'; cb.checked = it.sample !== false;
    cb.addEventListener('change', function () { it.sample = cb.checked; persist(); samplesBtn(); });
    l.appendChild(cb); l.appendChild(el('span', null, 'Sample'));
    return l;
  }
  function foot() {
    var f = el('footer', 'szp-foot');
    f.appendChild(el('span', null, [proj.name, proj.client].filter(Boolean).join(' — ')));
    f.appendChild(el('span', null, 'Studio Zen Wallcoverings · studiozenwallcoverings.com'));
    return f;
  }

  function itemPage(d, it, i, total) {
    var s = el('section', 'szp-page szp-item' + (d.room ? '' : ' szp-item--solo'));
    var media = el('div', 'szp-item__media');
    var sw = el('figure', 'szp-item__swatch');
    sw.appendChild(frame(d.img, title(d) + ' sample'));
    sw.appendChild(el('figcaption', null, 'Sample'));
    media.appendChild(sw);
    if (d.room) { var rm = el('figure', 'szp-item__room'); rm.appendChild(frame(d.room, title(d) + ' installed', 'szp-ph--room')); rm.appendChild(el('figcaption', null, d.roomCap || 'Installation')); media.appendChild(rm); }
    var info = el('div', 'szp-item__info');
    info.appendChild(el('p', 'szp-item__num', num(i) + ' / ' + num(total - 1)));
    info.appendChild(el('h2', 'szp-item__design', d.design || it.sku));
    if (d.colour) info.appendChild(el('p', 'szp-item__colour', d.colour));
    info.appendChild(el('p', 'szp-item__sku', it.sku));
    if (d.missing) info.appendChild(el('p', 'szp-item__warn', 'This item is no longer shown online. Please ask us about it.'));
    info.appendChild(specs(d, 'szp-specs'));
    info.appendChild(editableNote(it, 'szp-note'));
    if (d.url) { var a = el('a', 'szp-item__link', 'View online'); a.href = d.url; a.setAttribute('data-noprint', ''); info.appendChild(a); }
    info.appendChild(pick(it));
    info.appendChild(tools(i));
    s.appendChild(media); s.appendChild(info); s.appendChild(foot());
    return s;
  }
  function gridPage(chunk, start, total) {
    var s = el('section', 'szp-page szp-grid4');
    var g = el('div', 'szp-grid4__cells');
    chunk.forEach(function (pair, k) {
      var d = pair[0], it = pair[1], i = start + k, c = el('article', 'szp-cell');
      var m = el('div', 'szp-cell__media' + (d.room ? ' has-room' : ''));
      m.appendChild(frame(d.img, title(d) + ' sample'));
      if (d.room) { var rf = frame(d.room, title(d) + ' installed', 'szp-ph--room'); rf.appendChild(el('span', 'szp-ph__cap', (d.roomCap || 'Installation').replace('Installation · ', '').replace(/^./, function (c) { return c.toUpperCase(); }))); m.appendChild(rf); }
      c.appendChild(m);
      var t = el('div', 'szp-cell__text');
      t.appendChild(el('p', 'szp-item__num', num(i)));
      t.appendChild(el('h3', 'szp-cell__design', d.design || it.sku));
      t.appendChild(el('p', 'szp-cell__colour', [d.colour, it.sku].filter(Boolean).join(' · ')));
      t.appendChild(specs(d, 'szp-specs szp-specs--mini'));
      t.appendChild(editableNote(it, 'szp-note szp-note--mini'));
      t.appendChild(pick(it));
      t.appendChild(tools(i));
      c.appendChild(t); g.appendChild(c);
    });
    s.appendChild(g); s.appendChild(foot());
    return s;
  }

  /* ---------- several projects (10/15, Toshi: "definitely") ----------
     One browser keeps a list of projects (localStorage 'szw-projects-v1' already held { active, list }, so the single
     project from before simply becomes the first entry). "Projects (N)" opens the list under the toolbar: open, rename,
     duplicate, delete (inline confirm, never a browser dialog), New project. Colour pages save into the open project. */
  var confirmId = null;
  function countTxt(n) { return n + (n === 1 ? ' color' : ' colors'); }
  function dayTxt(t) { try { return new Date(t).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; } }
  function uniqueName(base) {
    var names = {}; state.list.forEach(function (p) { names[(p.name || '').toLowerCase()] = 1; });
    if (!names[base.toLowerCase()]) return base;
    for (var k = 2; ; k++) if (!names[(base + ' ' + k).toLowerCase()]) return base + ' ' + k;
  }
  function leaveShared() { shared = false; revealPicks = false; history.replaceState(null, '', location.pathname + location.search); }
  function openProject(p, focusName) {
    proj = p; state.active = p.id; save(state); leaveShared(); confirmId = null;
    panel(false); render(); window.scrollTo(0, 0);
    if (focusName) { var n = $('[data-szp-name]'); if (n) n.focus(); }
  }
  function panel(open) {
    var box = $('[data-szp-projects]'), b = $('[data-szp-projbtn]');
    if (!box) return;
    if (open == null) open = box.hidden;
    box.hidden = !open; if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      renderList();
      var bar = $('.szp-bar'); if (bar) document.documentElement.style.setProperty('--szp-bar-h', bar.offsetHeight + 'px');
      // phone (toolbar not sticky): bring the list into view
      if (bar && getComputedStyle(bar).position !== 'sticky' && box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'start' });
    } else confirmId = null;
  }
  function renderList() {
    var ul = $('[data-szp-plist]'); if (!ul) return;
    ul.innerHTML = '';
    var list = state.list.slice().sort(function (a, b) { return (b.updated || 0) - (a.updated || 0); });
    if (!list.length) { ul.appendChild(el('li', 'szp-prow szp-prow--none', 'No saved projects yet.')); return; }
    list.forEach(function (p) {
      var cur = !shared && p.id === proj.id, li = el('li', 'szp-prow' + (cur ? ' is-current' : ''));
      var nm = p.name || 'My project';
      if (confirmId === p.id) {
        li.classList.add('is-confirm');
        var q = el('p', 'szp-prow__q'); q.appendChild(document.createTextNode('Delete ')); q.appendChild(el('strong', null, nm));
        q.appendChild(document.createTextNode('? Its colors and notes are removed from this browser.')); li.appendChild(q);
        var acts = el('div', 'szp-prow__acts');
        var yes = el('button', 'szp-btn', 'Delete'); yes.type = 'button';
        yes.addEventListener('click', function () { del(p.id); });
        var no = el('button', 'szp-link', 'Cancel'); no.type = 'button';
        no.addEventListener('click', function () { confirmId = null; renderList(); });
        acts.appendChild(yes); acts.appendChild(no); li.appendChild(acts); ul.appendChild(li);
        setTimeout(function () { no.focus(); }, 0);
        return;
      }
      var open = el('button', 'szp-prow__open'); open.type = 'button';
      open.appendChild(el('span', 'szp-prow__name', nm));
      open.appendChild(el('span', 'szp-prow__meta', countTxt(p.items.length) + (p.client ? ' · ' + p.client : '') + ' · ' + dayTxt(p.updated)));
      if (cur) { open.setAttribute('aria-current', 'true'); open.appendChild(el('span', 'szp-prow__tag', 'Open')); }
      open.addEventListener('click', function () { if (cur) panel(false); else openProject(p); });
      li.appendChild(open);
      var acts2 = el('div', 'szp-prow__acts');
      [['Rename', function () { openProject(p, true); }],
       ['Duplicate', function () { dup(p); }],
       ['Delete', function () { confirmId = p.id; renderList(); }]].forEach(function (a) {
        var x = el('button', 'szp-link', a[0]); x.type = 'button'; x.setAttribute('aria-label', a[0] + ' ' + nm); x.addEventListener('click', a[1]); acts2.appendChild(x);
      });
      li.appendChild(acts2); ul.appendChild(li);
    });
  }
  function newProject() {
    var p = blank(uniqueName('New project')); state.list.push(p);
    openProject(p, true); toast('New project started. Name it, then save colors into it.');
  }
  function dup(p) {
    var c = JSON.parse(JSON.stringify(p)); c.id = uid(); c.name = uniqueName((p.name || 'My project') + ' (copy)'); c.updated = Date.now();
    state.list.push(c); save(state); renderList(); refreshCount(); toast('Duplicated as "' + c.name + '".');
  }
  function del(id) {
    var gone = state.list.filter(function (x) { return x.id === id; })[0];
    state.list = state.list.filter(function (x) { return x.id !== id; }); confirmId = null;
    if (!shared && proj.id === id) {
      var next = state.list.slice().sort(function (a, b) { return (b.updated || 0) - (a.updated || 0); })[0];
      if (!next) { next = blank(); state.list.push(next); }
      proj = next; state.active = next.id;
    }
    save(state); render(); renderList(); toast('Deleted "' + ((gone && gone.name) || 'project') + '".');
  }
  function refreshCount() { var c = $('[data-szp-pcount]'); if (c) c.textContent = state.list.length ? '(' + state.list.length + ')' : ''; }

  /* ---------- samples: only the ticked colours (10/15) ---------- */
  var revealPicks = false;
  function ticked() { return proj.items.filter(function (it) { return it.sample !== false; }); }
  function samplesBtn() {
    var b = $('[data-szp-samples]'), hint = $('[data-szp-samplehint]'); if (!b || b._busy) return;
    var hide = shared && !revealPicks;
    document.body.classList.toggle('szp-picks-off', hide);
    var n = ticked().length, w = n === 1 ? 'sample' : 'samples';
    var plain = hide || n === 0;
    b.textContent = isTrade ? (plain ? 'Add samples to cart' : 'Add ' + n + ' ' + w + ' to cart') : (plain ? 'Request samples' : 'Request ' + n + ' ' + w);
    // 10/15: guests (and clients on a shared link) go through the guest request, which is 3 samples at most
    var over = !isTrade && !hide && n > GS_MAX, lim = $('[data-szp-guestlimit]');
    b.disabled = !hide && (n === 0 || over);
    if (hint) hint.hidden = hide || n > 0;
    if (lim) lim.hidden = !over;
  }

  var renderSeq = 0;
  function render() {
    var seq = ++renderSeq;
    var nm = $('[data-szp-name]');
    if (nm && document.activeElement !== nm) nm.value = proj.name || 'My project';
    refreshCount();
    if (!$('[data-szp-projects]').hidden) renderList();
    // header fields
    $$('[data-szp-field]').forEach(function (f) {
      var k = f.getAttribute('data-szp-field');
      if (document.activeElement !== f) f.textContent = proj[k] || '';
      f.classList.toggle('is-empty', !proj[k]);
    });
    $$('[data-szp-echo]').forEach(function (f) { f.textContent = proj[f.getAttribute('data-szp-echo')] || ''; });
    $$('[data-szp-layout]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-szp-layout') === proj.layout ? 'true' : 'false'); });
    $('[data-szp-price]').checked = !!priceMode();
    var pmBox = $('[data-szp-pricemode]'), pBox = $('[data-szp-pricebox]');
    if (pmBox) { pmBox.hidden = !isTrade; if (pBox) pBox.hidden = isTrade;
      $$('[data-szp-pm]', pmBox).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-szp-pm') === priceMode() ? 'true' : 'false'); }); }
    $('[data-szp-shared]').hidden = !shared;
    samplesBtn();
    var empty = !proj.items.length;
    $('[data-szp-empty]').hidden = !empty;
    $('[data-szp-cover]').hidden = empty; $('[data-szp-overview]').hidden = empty;
    // nothing to lay out, print or share yet: the empty page keeps only the name and the way to browse
    var tl = $('.szp-bar__tools'); if (tl) tl.hidden = empty;
    var host = $('[data-szp-items]');
    if (empty) { host.innerHTML = ''; $('[data-szp-mosaic]').innerHTML = ''; $('[data-szp-ovgrid]').innerHTML = ''; return; }

    Promise.all(proj.items.map(function (it) { return item(it.sku); })).then(function (data) {
      if (seq !== renderSeq) return;
      var t = data.some(function (x) { return x && x.trade === 'true'; });
      if (t !== isTrade) { isTrade = t; render(); return; }
      // cover mosaic: up to 6 samples
      var withImg = data.filter(function (d) { return d.img; });
      var mo = $('[data-szp-mosaic]'); mo.innerHTML = ''; mo.setAttribute('data-n', Math.max(1, Math.min(withImg.length, 6)));
      withImg.slice(0, 6).forEach(function (d) { var c = el('div', 'szp-mosaic__cell'); if (d.img) c.appendChild(img(d.img, '')); mo.appendChild(c); });
      // overview
      var ov = $('[data-szp-ovgrid]'); ov.innerHTML = ''; ov.setAttribute('data-n', data.length);
      data.forEach(function (d, i) {
        var li = el('li', 'szp-ov'), f = el('div', 'szp-ov__img'); if (d.img) f.appendChild(img(d.img, title(d)));
        li.appendChild(f); li.appendChild(el('p', 'szp-item__num', num(i)));
        li.appendChild(el('p', 'szp-ov__design', d.design || proj.items[i].sku));
        li.appendChild(el('p', 'szp-ov__colour', [d.colour, proj.items[i].sku].filter(Boolean).join(' · ')));
        ov.appendChild(li);
      });
      $('[data-szp-overview]').hidden = data.length < 2;
      // items
      host.innerHTML = '';
      if (proj.layout === 'grid') {
        for (var i = 0; i < data.length; i += 4) {
          host.appendChild(gridPage(data.slice(i, i + 4).map(function (d, k) { return [d, proj.items[i + k]]; }), i, data.length));
        }
      } else {
        data.forEach(function (d, i) { host.appendChild(itemPage(d, proj.items[i], i, data.length)); });
      }
      samplesBtn();
    });
  }

  // header field edits
  $$('[data-szp-field]').forEach(function (f) {
    f.addEventListener('input', function () {
      var k = f.getAttribute('data-szp-field'); proj[k] = f.textContent.trim(); f.classList.toggle('is-empty', !proj[k]);
      $$('[data-szp-echo="' + k + '"]').forEach(function (e) { e.textContent = proj[k]; });
      persist();
      if (k === 'name') { var n = $('[data-szp-name]'); if (n) n.value = proj.name || 'My project'; }
    });
    f.addEventListener('keydown', function (e) { if (e.key === 'Enter' && f.tagName !== 'P') { e.preventDefault(); f.blur(); } });
    f.addEventListener('paste', function (e) { e.preventDefault(); document.execCommand('insertText', false, (e.clipboardData || window.clipboardData).getData('text/plain')); });
  });
  /* project name in the toolbar (10/12 owner review): click the name or the pencil, type, Enter or leave the field saves,
     Esc puts the old name back. Saved with the project (localStorage), so the cover, the printed / PDF sheets and the
     share link (which carries the name) all use it. */
  (function () {
    var box = $('[data-szp-namebox]'), inp = $('[data-szp-name]'), pen = $('[data-szp-rename]'), before = '';
    if (!inp) return;
    function apply(v) {
      proj.name = v;
      $$('[data-szp-field="name"]').forEach(function (f) { if (document.activeElement !== f) f.textContent = v; f.classList.toggle('is-empty', !v); });
      $$('[data-szp-echo="name"]').forEach(function (e) { e.textContent = v; });
    }
    function commit() {
      var v = inp.value.replace(/\s+/g, ' ').trim() || 'My project';
      inp.value = v; apply(v); persist(); box.classList.remove('is-editing');
      // the footers on the item sheets and the project list carry the name as well
      if (v !== before) render();
    }
    inp.addEventListener('focus', function () { before = proj.name || ''; box.classList.add('is-editing'); setTimeout(function () { inp.select(); }, 0); });
    inp.addEventListener('input', function () { apply(inp.value.trim()); });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); inp.blur(); }
      else if (e.key === 'Escape') { e.preventDefault(); inp.value = before || 'My project'; apply(inp.value); inp.blur(); }
    });
    inp.addEventListener('blur', commit);
    pen.addEventListener('click', function () { inp.focus(); });
  })();
  $('[data-szp-projbtn]').addEventListener('click', function () { panel(); });
  $('[data-szp-new]').addEventListener('click', newProject);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || $('[data-szp-projects]').hidden) return;
    if (confirmId) { confirmId = null; renderList(); } else { panel(false); $('[data-szp-projbtn]').focus(); }
  });
  $$('[data-szp-layout]').forEach(function (b) { b.addEventListener('click', function () { proj.layout = b.getAttribute('data-szp-layout'); persist(); render(); }); });
  $('[data-szp-price]').addEventListener('change', function (e) { proj.price = e.target.checked ? 'retail' : false; persist(); render(); });
  $$('[data-szp-pm]').forEach(function (b) { b.addEventListener('click', function () { proj.price = b.getAttribute('data-szp-pm') || false; persist(); render(); }); });

  /* ---------- PDF file name (10/15): browsers name a saved PDF after the page title ----------
     "Studio Zen Wallcoverings - <Project> - <Client> - <YYYY-MM-DD>", empty parts skipped, no characters a file name cannot
     hold, about 100 characters at most; set just before printing, the page title comes back afterwards. */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function isDefaultName(n) { return /^(my project|new project( \d+)?|shared project|untitled)$/i.test(String(n || '').trim()); }
  function clean(t) { return String(t || '').replace(/[\\\/:*?"<>|#%{}~&\u0000-\u001f]+/g, ' ').replace(/\s+/g, ' ').replace(/^[\s.\-]+|[\s.\-]+$/g, ''); }
  function fileTitle() {
    var parts = [];
    if (!isDefaultName(proj.name) && clean(proj.name)) parts.push(clean(proj.name));
    if (clean(proj.client)) parts.push(clean(proj.client));
    if (!parts.length) parts.push('Wallcovering selection');
    var dt = new Date(Date.parse(proj.date)); if (isNaN(dt.getTime())) dt = new Date();
    var ymd = dt.getFullYear() + '-' + pad(dt.getMonth() + 1) + '-' + pad(dt.getDate());
    var head = 'Studio Zen Wallcoverings - ', tail = ' - ' + ymd, room = 100 - head.length - tail.length, mid = parts.join(' - ');
    if (mid.length > room) mid = mid.slice(0, room).replace(/[\s\-]+\S*$/, '').replace(/[\s\-]+$/, '') || mid.slice(0, room);
    return head + mid + tail;
  }
  var pageTitle = null;
  function titleForPrint() { if (pageTitle == null) pageTitle = document.title; document.title = fileTitle(); }
  function titleBack() { if (pageTitle != null) { document.title = pageTitle; pageTitle = null; } }
  window.addEventListener('beforeprint', titleForPrint);
  window.addEventListener('afterprint', titleBack);
  $('[data-szp-print]').addEventListener('click', function () { titleForPrint(); window.print(); });

  // samples: approved trade -> the ticked colours' samples into the cart (memo samples are complimentary);
  // everyone else -> the guest sample request (10/15), the same tray + form as the colour pages
  var gs = guestRequest();
  (function () {
    var b = $('[data-szp-samples]'); if (!b) return;
    b.addEventListener('click', function () {
      // a client on a shared link sees the ticks first, then presses again
      if (shared && !revealPicks) { revealPicks = true; samplesBtn(); toast('Untick any colors you do not need, then press the button again.'); return; }
      var list = ticked(); if (!list.length) return;
      Promise.all(list.map(function (it) { return item(it.sku); })).then(function (d) {
        if (isTrade) {
          var items = d.filter(function (x) { return x && x.sample; }).map(function (x) { return { id: x.sample, quantity: 1 }; });
          var skip = d.map(function (x, i) { return x && x.sample ? null : ((x && x.sku) || list[i].sku); }).filter(Boolean);
          if (!items.length) { toast('No samples available for these items - please contact us.'); return; }
          b._busy = true; b.disabled = true; b.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { if (!r.ok) throw 0; location.href = '/cart'; })
            .catch(function () { b._busy = false; samplesBtn(); toast('Could not add the samples - please try again or contact us.'); });
          if (skip.length) toast('Not available as samples: ' + skip.join(', '));
        } else {
          if (list.length > GS_MAX) { samplesBtn(); return; }
          gs.open(d.map(function (x, i) {
            var sku = (x && x.sku) || list[i].sku, name = [x && x.design, x && x.colour].filter(Boolean).join(' - ') || sku;
            return { sku: sku, name: name, url: (x && x.url) || '', img: String((x && x.img) || '').replace(/([?&]width=)\d+/, function (m0, k) { return k + '160'; }) };
          }));
        }
      });
    });
  })();

  /* ---------- guest sample request window (10/15) ----------
     Markup + styles: snippets/szw-guest-sample-dialog.liquid (shared with the colour pages). The ticked colours REPLACE
     the guest tray (localStorage 'szwGuestSamples'), so what the window lists is exactly what is sent. The message is
     laid out like the colour pages' one (snippets/szw-guest-sample.liquid) - keep the two in step. */
  function guestRequest() {
    var dlg = $('[data-szw-gsd]'), bg = $('[data-szw-gsd-bg]'), form = dlg && dlg.querySelector('form');
    if (!dlg) return { open: function () {} };
    if (bg) document.body.appendChild(bg);
    document.body.appendChild(dlg);
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function tray() { try { var a = JSON.parse(localStorage.getItem(GS_KEY) || '[]'); return Array.isArray(a) ? a.slice(0, GS_MAX) : []; } catch (e) { return []; } }
    function f(n) { return form && form.querySelector('[data-szw-gs-f="' + n + '"]'); }
    function show() {
      var a = tray(), s = dlg.querySelector('[data-szw-gsd-samples]');
      if (s) s.innerHTML = a.length ? a.map(function (x, i) { return (i + 1) + '. ' + esc(x.sku) + ' &middot; ' + esc(x.name); }).join('<br>') : 'No samples chosen yet.';
      dlg.setAttribute('open', ''); if (bg) bg.hidden = false; document.documentElement.style.overflow = 'hidden';
      var first = dlg.querySelector('input:not([type=hidden]), button'); if (first) setTimeout(function () { first.focus(); }, 30);
    }
    function shut() { dlg.removeAttribute('open'); if (bg) bg.hidden = true; document.documentElement.style.overflow = ''; }
    dlg.addEventListener('click', function (e) { if (e.target.closest('[data-szw-gsd-close]')) shut(); });
    if (bg) bg.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dlg.hasAttribute('open')) shut(); });
    if (form) {
      $$('[data-szw-gs-designer]', form).forEach(function (r) {
        r.addEventListener('change', function () { form.querySelector('[data-szw-gs-designer-box]').hidden = form.querySelector('[data-szw-gs-designer]:checked').value !== 'Yes'; });
      });
      form.addEventListener('submit', function (e) {
        var a = tray();
        if (!a.length) { e.preventDefault(); return; }
        var v = function (n) { var el = f(n); return el ? el.value.trim() : ''; };
        var name = (v('first') + ' ' + v('last')).trim(), des = form.querySelector('[data-szw-gs-designer]:checked').value;
        f('fullname').value = name;
        f('body').value = [
          'GUEST SAMPLE REQUEST (' + a.length + ' of ' + GS_MAX + ')',
          '',
          'SAMPLES',
          a.map(function (x, i) { return (i + 1) + '. ' + x.sku + ' - ' + x.name; }).join('\n'),
          '',
          'SHIP TO',
          name,
          v('street'),
          v('city') + ', ' + v('state').toUpperCase() + ' ' + v('zip'),
          '',
          'Email: ' + v('email'),
          'Phone: ' + (v('phone') || '-'),
          'Working with a designer: ' + des + (des === 'Yes' && v('designer') ? ' - ' + v('designer') : ''),
          'Notes: ' + (v('notes') || '-'),
          '',
          'Sent from the project page' + (proj.name && !isDefaultName(proj.name) ? ': ' + proj.name : ''),
          'Pages: ' + a.map(function (x) { return x.url ? location.origin + x.url : x.sku; }).join(' ')
        ].join('\n');
        try { sessionStorage.setItem(GS_HASH, location.hash); } catch (e2) {}
      });
    }
    // back from Shopify: thank-you (empty the tray) or the form again with its error
    if (dlg.querySelector('[data-szw-gs-done]')) { try { localStorage.setItem(GS_KEY, '[]'); } catch (e) {} show(); }
    else if (dlg.querySelector('[data-szw-gs-error]')) show();
    return {
      open: function (items) {
        try { localStorage.setItem(GS_KEY, JSON.stringify(items.slice(0, GS_MAX))); } catch (e) {}
        show();
      }
    };
  }

  /* ---------- share (10/15): phones and tablets get the system share sheet (AirDrop, Messages, Mail); desktop copies ---------- */
  var touchShare = !!(navigator.share && window.matchMedia && matchMedia('(pointer: coarse)').matches);
  var shareBtn = $('[data-szp-share]');
  if (touchShare) shareBtn.textContent = 'Share';
  function shareUrl() { return location.origin + PAGE + '#p=' + pack(proj); }
  function copyLink(url) {
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      toast('Share link copied. Anyone with the link sees this project.');
    }, function () { window.prompt('Copy this link', url); });
  }
  shareBtn.addEventListener('click', function () {
    var url = shareUrl();
    if (!touchShare) { copyLink(url); return; }
    var parts = [isDefaultName(proj.name) ? 'Wallcovering selection' : proj.name, proj.client].filter(Boolean);
    navigator.share({ title: parts.join(' - ') + ' - Studio Zen Wallcoverings', url: url })
      .catch(function (e) { if (!e || e.name !== 'AbortError') copyLink(url); });
  });

  // a shared or binder link: "Save to my projects" keeps it as a NEW project in the list
  $('[data-szp-keep]').addEventListener('click', function () {
    proj.id = uid(); proj.updated = Date.now(); state.list.push(proj); state.active = proj.id; save(state);
    leaveShared(); toast('Saved as a new project: "' + (proj.name || 'Shared project') + '".'); render();
  });
  // another tab saved a colour or switched projects: follow it (own projects only)
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY || shared) return;
    state = load(); proj = active(state, true); render();
  });

  render();
})();
